import { baseApi } from "configs/store-query";
import { ApiResponse } from "./types";
import { ACCOUNT } from "constants/tags";
import { LoginResponse, register,login } from "./types/account";

const BASE_URL = `v1/account`;

const accountApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    loginAccount: builder.mutation<LoginResponse, login>({
      query: (payload) => ({
        method: "POST",
        url: `${BASE_URL}/login`,
        data: payload,
        headers: {
          'Content-Type': 'application/json-patch+json',
        },
      }),
      invalidatesTags: [{ type: ACCOUNT }],
    }),
    registerAccount: builder.mutation<ApiResponse<register>, any>({
      query: (payload) => ({
        method: "POST",
        url: `${BASE_URL}/register`,
        data: payload,
        headers: {
          'Content-Type': 'application/json-patch+json',
        },
      }),
      invalidatesTags: [{ type: ACCOUNT }],
    }),
    forgotPassword: builder.mutation({
      query: ({ path, ...config }: any) => {
        return {
          url: `${BASE_URL}/forgot-password`,
          method: 'post',
          ...config,
        }
      },
    }),
  }),
});

export default accountApi;
